import React, { Component } from "react";
import { ApolloProvider } from "react-apollo";
import { History } from "history";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
  RouteProps,
} from "react-router-dom";

import PageLayout from "./PageLayout";
import { client, SessionProvider } from "./session";
import * as urls from "./urls";
import HomePage from "./pages/HomePage";
import CreditsPage from "./pages/CreditsPage";
import LoginPage from "./pages/LoginPage";
import FourOhFourPage from "./pages/FourOhFourPage";
import DashboardPage from "./pages/DashboardPage";
import UserPage from "./user/UserPage";
import BoardPage from "./board/BoardPage";
import ChallengePage from "./challenge/ChallengePage";
import GamePage from "./game/GamePage";

// A route that remounts if the history length changes, i.e. clicking on a link
// to the current page. This is useful to force the page to refetch its data.
const RefreshingRoute: React.ComponentType<RouteProps> = withRouter(
  ({ history, ...rest }: { history: History } & RouteProps) => (
    <Route key={history.length} {...rest} />
  )
);

class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <SessionProvider>
          <Router>
            <PageLayout>
              <Switch>
                <Route path={urls.homeUrl} exact component={HomePage} />
                <Route path={urls.creditsUrl} exact component={CreditsPage} />
                <Route path={urls.boardPattern} exact component={BoardPage} />
                <Route path={urls.loginUrl} exact component={LoginPage} />
                <RefreshingRoute
                  path={urls.dashboardUrl}
                  exact
                  component={DashboardPage}
                />
                <RefreshingRoute
                  path={urls.userProfilePattern}
                  exact
                  component={UserPage}
                />
                <RefreshingRoute
                  path={urls.challengePattern}
                  exact
                  component={ChallengePage}
                />
                <RefreshingRoute
                  path={urls.gamePattern}
                  exact
                  component={GamePage}
                />
                <Route component={FourOhFourPage} />
              </Switch>
            </PageLayout>
          </Router>
        </SessionProvider>
      </ApolloProvider>
    );
  }
}

export default App;
